import React from 'react'

export const Text: React.FC = ({ children }) => {
  return (
    <p className="font-inter font-light text-lg text-black-lighter dark:text-text-70-dm ">
      {children}
    </p>
  )
}
